import MaterialUiDivider, { DividerProps } from "@material-ui/core/Divider";
import * as React from "react";

export const Divider: React.FC<DividerProps> = props => (
  <MaterialUiDivider {...props} />
);
